/* Evora — vídeos UGC (compartido por «Vídeos UGC», «UGC compacto» y el bloque UGC de la ficha).
   - El desplazamiento es 100 % nativo (scroll horizontal con snap): el dedo mueve la pista, el JS no intercepta el gesto.
   - Un toque (sin arrastrar) en la tarjeta = play/pausa. Un arrastre nunca cuenta como toque.
   - Autoplay silenciado de UN solo vídeo: el más visible. Los demás se pausan. Fuera de pantalla, todo pausado.
   - preload="none" hasta que la tarjeta se acerca; así el swipe no se atasca descargando vídeos. */
(function () {
  'use strict';
  var W = (window.EvoraUGC = window.EvoraUGC || {});
  if (W.ready) { run(); return; }
  W.ready = true;

  var TAP_SLOP = 10; /* px que puede moverse el dedo y seguir siendo un toque */

  function allVideos() { return document.querySelectorAll('[data-evora-ugc-section] video'); }

  W.init = function (root) {
    if (!root || root.hasAttribute('data-ugc-ready')) return;
    root.setAttribute('data-ugc-ready', '');
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var track = root.querySelector('[data-slider-track]');
    var vids = [];
    var ratios = new Map();
    root._ugcManual = false;
    root._ugcActive = null;
    var scrolling = false, scrollTimer = null;

    function playV(v) {
      if (v.preload !== 'auto') v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () { if (!v.muted) { v.muted = true; v.play().catch(function () {}); } });
    }
    function start(v) {
      v._userPaused = false;
      root._ugcActive = v;
      vids.forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
      if (!v.muted) allVideos().forEach(function (o) { if (o !== v && !o.muted) o.muted = true; });
      playV(v);
    }
    /* Elige el vídeo más visible (solo con autoplay y sin interacción manual) */
    function pickAuto() {
      if (!autoplay || root._ugcManual) return;
      var best = null, bestR = 0.6;
      vids.forEach(function (v) { var r = ratios.get(v) || 0; if (!v._userPaused && (best ? r > bestR : r >= bestR)) { best = v; bestR = r; } });
      vids.forEach(function (v) { if (v !== best && !v.paused) v.pause(); });
      if (best && best.paused) playV(best);
    }

    root.querySelectorAll('[data-ugc]').forEach(function (card) {
      var v = card.querySelector('video');
      if (!v) return;
      vids.push(v);
      v.muted = true; v.defaultMuted = true; v.loop = true; v.controls = false;
      v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      var pb = card.querySelector('[data-ugc-play]');
      var sb = card.querySelector('[data-ugc-sound]');

      function sync() {
        var on = !v.paused && !v.ended;
        var snd = !v.muted;
        card.classList.toggle('is-playing', on);
        if (pb) {
          pb.setAttribute('aria-pressed', on ? 'true' : 'false');
          pb.setAttribute('aria-label', on ? 'Pausar vídeo' : 'Reproducir vídeo');
          pb.querySelector('[data-icon-play]').hidden = on;
          pb.querySelector('[data-icon-pause]').hidden = !on;
        }
        if (sb) {
          sb.setAttribute('aria-pressed', snd ? 'true' : 'false');
          sb.setAttribute('aria-label', snd ? 'Silenciar vídeo' : 'Activar sonido');
          sb.querySelector('[data-icon-off]').hidden = snd;
          sb.querySelector('[data-icon-on]').hidden = !snd;
        }
      }
      ['play', 'playing', 'pause', 'ended', 'volumechange'].forEach(function (ev) { v.addEventListener(ev, sync); });
      sync();

      function toggle() {
        root._ugcManual = true;
        if (v.paused) start(v);
        else { v._userPaused = true; v.pause(); }
      }
      if (pb) pb.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(); });
      if (sb) sb.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        root._ugcManual = true;
        if (v.muted) {
          allVideos().forEach(function (o) { if (o !== v) o.muted = true; });
          v.muted = false; v.volume = 1;
          start(v);
        } else {
          v.muted = true;
        }
      });

      /* Toque vs. arrastre: solo un toque real alterna play/pausa */
      var sx = 0, sy = 0, moved = false;
      card.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; moved = false; }, { passive: true });
      card.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - sx) > TAP_SLOP || Math.abs(e.clientY - sy) > TAP_SLOP) moved = true; }, { passive: true });
      card.addEventListener('click', function (e) {
        if (e.target.closest('button, a')) return;
        if (moved || scrolling) return;
        toggle();
      });
    });

    if (!vids.length) return;

    if (track) {
      track.addEventListener('scroll', function () {
        scrolling = true;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () { scrolling = false; pickAuto(); }, 140);
      }, { passive: true });
    }

    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting && en.target.preload === 'none') en.target.preload = 'metadata'; });
      }, { rootMargin: '200px' });
      var view = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          ratios.set(v, en.isIntersecting ? en.intersectionRatio : 0);
          if (en.intersectionRatio < 0.25 && !v.paused) v.pause();
          if (root._ugcManual && root._ugcActive === v && en.intersectionRatio >= 0.6 && v.paused && !v._userPaused) playV(v);
        });
        if (!scrolling) pickAuto();
      }, { threshold: [0, 0.25, 0.6, 0.9, 1] });
      vids.forEach(function (v) { near.observe(v); view.observe(v); });
      root._ugcObservers = [near, view];
    }
  };

  W.destroy = function (root) {
    if (!root) return;
    (root._ugcObservers || []).forEach(function (o) { o.disconnect(); });
    root.querySelectorAll('video').forEach(function (v) { v.pause(); });
    root.removeAttribute('data-ugc-ready');
  };

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-evora-ugc-section]').forEach(W.init);
    if (window.Evora && window.Evora.initSliders) window.Evora.initSliders(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-evora-ugc-section]').forEach(W.destroy);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest && e.target.closest('[data-ugc-card], .ugc__slot');
    var track = card && card.closest('[data-slider-track]');
    if (track) track.scrollTo({ left: card.offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' });
  });

  function run() { document.querySelectorAll('[data-evora-ugc-section]').forEach(W.init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
